import React from 'react';
import styled from 'styled-components';
import {useSelector} from 'react-redux';

import {reviewStaticDataSelector} from '@ibibo/hotels-review-reducer';

import HotelImageWrap from '../HotelImageWrap/HotelImageWrap';
import HotelDetailsWrap from '../HotelDetailsWrap/HotelDetailsWrap';

import {detailsStaticDataSelector} from '../../../../../shared/pages/DetailsPage/selectors';

const HotelDetailsReview = () => {
  const {hn, address, hotelImage, hotelStars} = useSelector(reviewStaticDataSelector);
  const {detailsHotelName, detailsHotelAddress, detailsHotelStars, detailsRating} = useSelector(
    detailsStaticDataSelector,
  );

  return (
    <HotelDetailsReviewWrapDiv>
      <HotelImageWrap hotelImage={hotelImage} />
      <HotelDetailsWrap
        hn={hn || detailsHotelName}
        address={address || detailsHotelAddress}
        hotelStars={hotelStars || detailsHotelStars}
        rating={detailsRating}
      />
    </HotelDetailsReviewWrapDiv>
  );
};

export default HotelDetailsReview;

const HotelDetailsReviewWrapDiv = styled.div(
  props => `
    display:flex;
    flex-wrap: wrap;
    flex-direction: row;
    width:100%;
    padding-bottom:${props.theme.spacing.large.l20};
  `
);
